import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Button } from 'src/shared/components/Button';
import { Modal } from 'src/shared/components/Modal';
import { layout } from 'src/shared/styles/variables';

interface StyledModalProps {
    noPadding?: boolean;
    centeredText?: boolean;
}

const StyledModal = styled(Modal)<StyledModalProps>(({ noPadding, centeredText }) => ({
    '& .ant-modal-content': {
        display: 'flex',
        maxWidth: layout.modalWidth.wide,
        margin: '0 auto',
        padding: noPadding ? '0' : '1.75rem 3.50rem',
        textAlign: centeredText ? 'center' : 'left',
    },
    '& .ant-modal-body': {
        padding: noPadding ? '0' : '1.75rem',
    },
}));

interface Props extends WithTranslation {
    centeredText?: boolean;
    closable?: boolean;
    noPadding?: boolean;
    isVisible: boolean;
    onCancel: () => void;
    nextStep: () => void;
    noButton?: boolean;
    children: ReactNode;
}

export const StepModal = withTranslation()(
    ({
        isVisible,
        children,
        noPadding,
        closable,
        centeredText,
        noButton,
        t,
        onCancel,
        nextStep,
    }: Props) => (
        <StyledModal
            centeredText={centeredText}
            noPadding={noPadding}
            closable={closable}
            visible={isVisible}
            onCancel={onCancel}
            footer={null}
            width="auto"
            centered
        >
            {children}
            {noButton ? null : <Button onClick={nextStep}>{t('common.continue')} </Button>}
        </StyledModal>
    ),
);
